import { useMemo } from 'react';
import { Params, useLocation, useParams } from 'react-router-dom';
import { useSingleCustomer } from '../useSingleCustomer';

export type NavigationEvent = {
  path: string;
  displayName: string;
  isLast: boolean;
  params?: Readonly<Params<string>>;
};

const mainPages = ['/clientes', '/configuracoes'];

export const useNavigationEvents = () => {
  const location = useLocation();
  const params = useParams();


  const navigationEvents = useMemo((): any => {
    const paths = location.pathname.split('/').filter(Boolean);
    
     if (mainPages.includes('/' + paths[0]) && paths.length === 1) {
      return [];
    }

    let events: NavigationEvent[] = [];

    if (paths[0] === 'clientes') {
      events.push({
        path: '/clientes',
        displayName: 'Clientes',
        isLast: paths.length === 1,
        params,
      });
    }

    if (paths[0] === 'clientes' && params.customerId) {
      const { data: customer } = useSingleCustomer(params.customerId || '');
      
      if (customer) {
        events.push({
          path: `/clientes/${params.customerId}`,
          displayName: customer.defaultMember?.name || 'Cliente',
          isLast: paths.length === 2,
          params,
        });
      }
    }

    return events;
  }, [location, params]);

  return { navigationEvents, currentPath: location.pathname, params };
};